<template>
  <section class="content">
    <div class="row">
      <div class="col-xs-12 m-b-10" v-if="getRoleType === 99 || getRoleType === 30">
        <router-link :to="{
          name: 'brandMenuTable',
          params: {
            brand_id: $route.params.brand_id
          }
        }">
          <div class="btn btn-default">
            返回品牌菜單管理
          </div>
        </router-link>
      </div>

      <div class="col-md-12">
        <div class="box">
          <div class="box-body">
            <div class="row">
              <div class="col-sm-12 mb-3">
                <div
                  class="btn btn-default btn-table-title"
                  data-toggle="modal"
                  data-target="#editModal"
                  v-text="'不可編輯菜單門市設定'"
                />
                <router-link :to="{
                  name: 'MenuSettingRuleStoreUpdateLogsView'
                }">
                  <div
                    class="btn btn-default btn-table-title"
                    v-text="'操作歷程'"
                  />
                </router-link>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table
                  v-if="setting.blacklist"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>設定</th>
                      <th>門市</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="w-xs">1</td>
                      <td class="w-sm">可編輯菜單門市</td>
                      <td class="w-auto" v-text="whitelist" />
                    </tr>
                    <tr>
                      <td class="w-xs">2</td>
                      <td class="w-sm">不可編輯菜單門市</td>
                      <td class="w-auto" v-text="blacklist" />
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <m-modal
      :option="black.option"
      @trigger="trigger"
    >
      <template v-slot:body>
        <div>
          <div class="mb-2">請選擇要新增或編輯至不可編輯的門市</div>
          <multiselect
            v-model="black.temp"
            :label="black.label"
            :options="setting.whitelist"
            :multiple="true"
            :placeholder="black.placeholder"
            :tag-placeholder="black.placeholder"
            :track-by="black.trackBy"
          />
        </div>
      </template>
    </m-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'

// components
import matcherModal from '@/components/elements/Modal'

export default {
  name: 'MenuSettingRuleStoreUpdate',
  components: {
    'm-modal': matcherModal
  },
  data () {
    return {
      black: {
        label: 'name',
        option: {
          id: 'editModal',
          title: '不可編輯菜單門市設定',
          btns: [
            {
              name: '取消'
            },
            {
              name: '確定',
              event: 'update'
            }
          ]
        },
        placeholder: '請輸入或選擇門市',
        temp: [],
        trackBy: 'id'
      },
      setting: {
        blacklist: [],
        whitelist: []
      }
    }
  },
  methods: {
    getList () {
      const brandId = this.$route.params.brand_id
      const url = `/brand/${brandId}/storeMenuUpdateSetting`
      this.getDataH('get', url, null, (res) => {
        if (res.data.status === 200) {
          const blacklist = this.handleList(res.data.setting.blacklist)
          const whitelist = this.handleList(res.data.setting.whitelist)
          this.black.temp = blacklist
          this.setting.blacklist = blacklist
          this.setting.whitelist = whitelist
        }
      })
    },
    handleList (list = []) {
      return list.map((i) => {
        let temp = {
          id: i.id,
          name: i.name
        }
        if (!i.name) {
          temp.name = `[${i.id}][無門市名稱]`
        }
        return temp
      })
    },
    trigger (event) {
      if (event === 'update') {
        this.update()
      }
    },
    update () {
      console.log('update')
      const brandId = this.$route.params.brand_id
      const url = `/brand/${brandId}/storeMenuUpdateSetting`
      this.getDataH('post', url, this.updateInfo, (res) => {
        if (res.data.status === 200) {
          this.$notify({
            title: '設定成功',
            text: '已設定不可編輯門市！',
            duration: 1000,
            type: 'success',
            width: 400
          })
          this.getList()
        }
      })
    }
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    blacklist () {
      const temp = this.setting.blacklist.map((i) => i.name)
      return temp.join('、')
    },
    blackTempId () {
      const temp = this.black.temp.map((i) => i.id)
      return temp
    },
    updateInfo () {
      return {
        blacklist: this.blackTempId
      }
    },
    whitelist () {
      const temp = this.setting.whitelist.map((i) => i.name)
      return temp.join('、')
    }
  }
}
</script>

<style lang="scss" scoped>
.w-xs {
  width: 40px;
}
.w-sm {
  width: 180px;
}
.w-auto {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// MenuSettingRuleStoreUpdate.vue?50c86a28